import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { EscolaLegislativoBanner01 } from './escolaLegislativo/EscolaLegislativoBanner01';
import { EscolaLegislativoBanner02 } from './escolaLegislativo/EscolaLegislativoBanner02';
import { EscolaLegislativoBanner03 } from './escolaLegislativo/EscolaLegislativoBanner03';
import { EscolaLegislativoRodape } from './escolaLegislativo/EscolaLegislativoRodape';

export default function EscolaLegislativoHome() {
  const theme = useTheme();

  //console.log("Theme",  theme.custom)

  return (
    <Box sx={{ width: '100%', gap: 2 }}>
      <EscolaLegislativoBanner01 />
      <EscolaLegislativoBanner02 />
      <EscolaLegislativoBanner03 />
      <EscolaLegislativoRodape />
    </Box>
  );
}
